// ==========================================================================
// Plyr Polyfilled Build
// plyr.js v3.8.5 x-release-please-version
// https://github.com/sampotts/plyr
// License: The MIT License (MIT)
// ==========================================================================

import Plyr from './plyr';
import 'custom-event-polyfill';

import 'url-polyfill';

export default Plyr;
